/**
 * Copy of Operations › PO fulfilment's retailer view
 * (`components/Operations/RetailerPoFulfilment.tsx`), from VentaHub's
 * "Purchase order fill rate". The page title and tabs are `poFulfilment`'s.
 */
export const retailerPoFulfilment = {
  subtitle:
    'Retailer purchase orders: how much was confirmed, invoiced and delivered, from our own records.',
  chooseTitle: 'Choose a marketplace',
  chooseHint:
    'Choose a marketplace to see its purchase orders. The window is the last 30 days until you pick other dates.',
  loadMore: 'Load more',
  loadingMore: 'Loading…',
  download: 'Download report',
  downloadHint: 'Excel workbook for this window: totals by retailer, every PO, and every line item',
  exporting: 'Preparing…',
  open: 'Open {{code}}',
  rateHint: '{{percent}} of ordered units',
  // The saved report's name.
  exportName: '{{marketplace}} retailer PO fill rate.xlsx',
  filters: {
    marketplace: 'Marketplace',
    chooseMarketplace: 'Choose a marketplace',
    dates: 'Purchase date',
    status: 'Status',
    allStatuses: 'All statuses',
  },
  columns: {
    poCode: 'PO number',
    poDate: 'Purchase date',
    retailer: 'Retailer',
    warehouse: 'Warehouse',
    validTill: 'Valid till',
    skus: 'SKUs',
    amount: 'Amount',
    status: 'Status',
    sku: 'SKU',
  },
  stages: {
    ordered: 'Ordered',
    confirmed: 'Confirmed',
    blocked: 'Blocked',
    allotted: 'Allotted',
    invoiced: 'Invoiced',
    dispatched: 'Dispatched',
    delivered: 'Delivered',
    open: 'Still open',
    fillRate: 'Fill rate',
    confirmRate: 'Confirmed rate',
    deliveryRate: 'Delivered rate',
    valueOrdered: 'Ordered value',
  },
  status: {
    not_started: 'Not started',
    in_progress: 'In progress',
    invoiced: 'Invoiced in full',
    delivered: 'Delivered',
    expired: 'Expired',
  },
  summary: {
    title: 'Summary by retailer',
    window: 'Purchase orders dated {{from}} to {{to}}',
    pos: 'POs',
    total: 'All retailers',
    empty: 'No purchase orders for this marketplace in the selected window.',
    emptyHint: 'Try a wider window, or another marketplace.',
  },
  list: {
    title: 'Purchase orders',
    empty: 'No purchase orders found for this marketplace.',
    emptyHint: 'Try a wider window, or clear the status.',
  },
  detail: {
    title: 'PO {{code}}',
    close: 'Close',
    covered: 'Units covered',
    coveredValue: '{{covered}} of {{ordered}}',
  },
  lines: {
    empty: 'This PO has no lines.',
    emptyHint: 'It was raised without any SKUs.',
  },
} as const
